import React from "react";

interface ProgressBarProps {
  totalSegments: number;
  filledSegments: number;
  halfSegmentIndex: number | null;
  unfilledClassName?: string;
}

export const ProgressBar = ({
  totalSegments,
  filledSegments,
  halfSegmentIndex,
  unfilledClassName = "bg-gray-4",
}: ProgressBarProps) => (
  <div className="flex gap-1 items-center w-full">
    {Array.from({ length: totalSegments }).map((_, index) => {
      const isFilled = index < filledSegments;
      const isHalf = index === halfSegmentIndex;

      if (isHalf) {
        return (
          <div key={index} className={`flex-1 h-1 rounded-full ${unfilledClassName} overflow-hidden`}>
            <div className="h-full w-1/2 bg-gv-yellow rounded-full" />
          </div>
        );
      }

      return (
        <div
          key={index}
          className={`flex-1 h-1 rounded-full transition-colors duration-300 ${
            isFilled ? "bg-gv-yellow" : unfilledClassName
          }`}
        />
      );
    })}
  </div>
);
